module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/vip7-2353173171491a3532d3de0d468df3d6.png";